module.exports = __webpack_public_path__ + "static/media/sorting_icon_up_active.f3850e16.svg";